import { call, put, takeLatest } from "redux-saga/effects";
import { insurancePaymentRequest, insurancePaymentSuccess, insurancePaymentFailure, insurancePaymentStatusRequest, insurancePaymentStatusSuccess, insurancePaymentStatusFailure, insurancePaymentFinalRequest, insurancePaymentFinalSuccess, insurancePaymentFinalFailure } from "../../slice/travel-insurance/paymentSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
// Initial Payments API Call
const fetchInsurancePaymentData = async data => {
  const PAYMENT_URL = config?.ROP_DAPI_INSURANCE_PAYMENT_API;
  const headerData = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${PAYMENT_URL}`, data, headerData);
  return response;
};
function* getInsurancePaymentData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchInsurancePaymentData, payload);
    yield put(insurancePaymentSuccess(response.data));
  } catch (error) {
    yield put(insurancePaymentFailure(error));
  }
}
export function* watchInsurancePaymentData() {
  yield takeLatest(insurancePaymentRequest.type, getInsurancePaymentData);
}

// Payment Status API Call
const fetchInsurancePaymentStatusData = async data => {
  const PAYMENT_URL = config?.ROP_DAPI_INSURANCE_PAYMENT_STATUS_API;
  const headerData = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36"
    },
    loader: true,
    isGenericErr: false,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${PAYMENT_URL}`, data, headerData);
  return response;
};
function* getInsurancePaymentStatusData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchInsurancePaymentStatusData, payload);
    yield put(insurancePaymentStatusSuccess(response.data));
  } catch (error) {
    yield put(insurancePaymentStatusFailure(error));
  }
}
export function* watchInsurancePaymentStatusData() {
  yield takeLatest(insurancePaymentStatusRequest.type, getInsurancePaymentStatusData);
}

// Payment Final API Call
const fetchInsurancePaymentFinalData = async data => {
  const PAYMENT_URL = config.DAPI_INSURANCE_PAYMENT_FINALIZE_API;
  const headerData = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36"
    },
    loader: true,
    isGenericErr: false,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${PAYMENT_URL}`, data, headerData);
  return response;
};
function* getInsurancePaymentFinalData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchInsurancePaymentFinalData, payload);
    yield put(insurancePaymentFinalSuccess(response.data));
  } catch (error) {
    yield put(insurancePaymentFinalFailure(error));
  }
}
export function* watchInsurancePaymentFinalData() {
  yield takeLatest(insurancePaymentFinalRequest.type, getInsurancePaymentFinalData);
}